import { AxiosResponse } from "axios";
import { axiosInstanceMain } from "../../../utils/axiosGlobalUtils";
import { StatusHistoriasResponse } from "../types";
import { ITenant } from "../../AbmLocalPage/types";

export const GetStatus = async (idLocal: number, tenant: ITenant) =>
  (await axiosInstanceMain.get(
    `/${tenant.path}/historias/status-local/${idLocal}`
  )) as AxiosResponse<StatusHistoriasResponse>;

export const ComprarHistoria = async (
  idLocal: number,
  cant: number,
  tenant: ITenant
) =>
  await axiosInstanceMain.post(
    `/admin/${tenant.path}/historias/local-compra-paquete/${idLocal}?cant=${cant}`
  );

export const cargarHistoria = async (tenant: ITenant) =>
  axiosInstanceMain.post(`/${tenant.path}/historias`);